import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { FundScreenerSessionResponse } from '@repo/tools-types'

const initialState: GenericOperationState<FundScreenerSessionResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: fundScreenerSessionDataActions, reducer: fundScreenerSessionDataReducers } =
  createOperationSlice<
    FundScreenerSessionResponse | null,
    SliceCaseReducers<GenericOperationState<FundScreenerSessionResponse | null>>
  >({
    name: '@tools/fundScreener/session',
    initialState,
    reducers: {},
  })
